import '../../../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'OmProblemLog',
  components: {
    datetime: Datetime,
    DateTime,
    DetailsComp: require('./details.vue').default,
    AttachmentsComp: require('./attachments.vue').default,
    /*HyperlinksComp: require('./hyperlinks.vue').default,*/
  },
  props: ['dataObj'],
  data: function () {
    return {
      currentPage: 'details',
      message: '',
    }
  },
  created() {

  },
  methods: {
    gotoPage(page) {
      this.currentPage = page;
      switch (page) {
        case "details":
          break;
        case "attachments":
          break;
        case "hyperlinks":
          break;
        default:
        // do nothing
      }
    },
  },

}

